import { Injectable } from '@angular/core';
import { take, tap } from 'rxjs/operators';

import { CompanySelection } from '@com-delta-idp/mnx-capability-profile-selector-ui';
import {
  DEFAULT_COOKIE_DOMAIN_VALUE,
  PERM_TYPE,
  PERSONAL
} from '../constants/profile-selector-constants';
import { PROFILE_ACCOUNT_COOKIE } from '../models/profile-selector.interface';
import { ProfileSelectorUtilHelperService } from './profile-selector-util-helper.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorUtilService extends ProfileSelectorUtilHelperService {
  switchBusinessAccountOverlay(
    companyName: string,
    permType: string,
    fromStandAlone: boolean
  ): void {
    const elementTag = document.querySelector(
      'ngc-switching-account'
    ) as HTMLElement;

    if (this.switchBusinessAccountOverlayHelper(elementTag, permType)) {
      this.setProfileModalAttributes(elementTag, companyName);
    } else {
      this.resetProfileModalAndReload(elementTag, fromStandAlone, permType);
    }
  }

  private setProfileModalAttributes(
    elementTag: HTMLElement,
    companyName: string
  ): void {
    elementTag?.setAttribute('newProfileModalSelected', 'true');
    elementTag?.setAttribute('companyName', companyName);
  }

  private resetProfileModalAndReload(
    elementTag: HTMLElement,
    fromStandAlone: boolean,
    permType: string
  ): void {
    elementTag?.setAttribute('newProfileModalSelected', 'false');
    elementTag?.removeAttribute('companyName');
    if (this.shouldReload(fromStandAlone, permType)) {
      window.location.reload();
    }
  }

  private shouldReload(fromStandAlone: boolean, permType: string): boolean {
    if (fromStandAlone) return false;
    const headerTop = document.querySelector('.header__top') as HTMLElement;
    return !(headerTop && permType !== PERM_TYPE.P);
  }

  getBusinessAccountState(): {
    businessAccountIndex: number;
    isBusiness: boolean;
  } {
    const accountCookie = this.cookieHelper.getAccountCookie('account');
    const parseAccount = JSON.parse(accountCookie);
    const businessAccountOptionsList =
      parseAccount['businessAccountOptionsList'];
    return {
      businessAccountIndex: businessAccountOptionsList['accountIndex']
        ? parseInt(businessAccountOptionsList['accountIndex'])
        : 0,
      isBusiness: parseAccount['isBusiness']
    };
  }

  transformAccountCookieObject(
    params: CompanySelection
  ): PROFILE_ACCOUNT_COOKIE {
    if (params.permType !== PERM_TYPE.P) {
      return {
        isBusiness: true,
        name: encodeURIComponent(params.companyName.toString()),
        businessAccountOptionsList: {
          isOaSmeAccount: params.isOaSmeAccount,
          partnerId: params.partnerId,
          accountIndex: params.accountIndex,
          restrictPaxToOne: params.restrictOnePax,
          displayInlineText: params.displayInlineText,
          disableMiles: params.disableMiles
        }
      };
    } else {
      return {
        isBusiness: false,
        name: encodeURIComponent(params.companyName.toString()),
        businessAccountOptionsList: {
          isOaSmeAccount: false,
          partnerId: PERSONAL,
          accountIndex: 0,
          restrictPaxToOne: false,
          displayInlineText: '',
          disableMiles: false
        }
      };
    }
  }

  setAccountCookie(params: CompanySelection): void {
    const accountType = JSON.stringify(
      this.transformAccountCookieObject(params)
    );
    this.userData
      .getAuthConfigContent()
      .pipe(
        take(1),
        tap((authConfig) => {
          this.cookieHelper.setCookieName(
            'account',
            accountType,
            0,
            true,
            '/',
            authConfig.COOKIE_DOMAIN_VALUE ?? DEFAULT_COOKIE_DOMAIN_VALUE
          );
        })
      )
      .subscribe();
  }

  getAdminUrl(aemContentForAdmin: string, userIdVal: string): string {
    const adminLinkUrl = aemContentForAdmin
      ? `${aemContentForAdmin}${userIdVal}`
      : '';
    return adminLinkUrl;
  }
}
